import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { EntityTagFilter } from '../../filters.esm.js';
import { EntityAutocompletePicker } from '../EntityAutocompletePicker/EntityAutocompletePicker.esm.js';
import { catalogReactTranslationRef } from '../../translation.esm.js';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';

const useStyles = makeStyles(
  { input: {} },
  { name: "CatalogReactEntityTagPicker" }
);
const EntityTagPicker = (props) => {
  const classes = useStyles();
  const { t } = useTranslationRef(catalogReactTranslationRef);
  return /* @__PURE__ */ React.createElement(
    EntityAutocompletePicker,
    {
      label: t("entityTagPicker.title"),
      name: "tags",
      path: "metadata.tags",
      Filter: EntityTagFilter,
      showCounts: props.showCounts,
      InputProps: { className: classes.input }
    }
  );
};

export { EntityTagPicker };
//# sourceMappingURL=EntityTagPicker.esm.js.map
